import React from 'react';
import ReactDOM from 'react-dom/client';
// Polices de la charte servies localement (pas de Google Fonts à l'exécution, §3.4)
import '@fontsource-variable/sora/wght.css';
import '@fontsource-variable/public-sans/wght.css';
import '@fontsource-variable/jetbrains-mono/wght.css';
import App from './App.jsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
